module.exports = __webpack_public_path__ + "static/media/pdfSvg.2276a13c.svg";